import { Cpu } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const CpuIcon = createLucideIcon(Cpu);
